import { useEffect, useState } from "react";
import { getBasePathFromWidgetSource } from "../config/config";

export default function useFetchStylesheet(): [boolean] {
    const [loaded, setLoaded] = useState<boolean>(false);

    useEffect(() => {
        const stylesheet = document.getElementById("xapp-style");

        if (!stylesheet) {
            const cdnPath = getBasePathFromWidgetSource();
            const link = document.createElement("link");
            link.id = "xapp-style";
            link.href = `${cdnPath.path}/xapp-chat-widget.css`;
            link.rel = "stylesheet";
            document.head.appendChild(link);
            link.addEventListener("load", () => {
                setLoaded(true);
            });
        }
    }, []);

    return [loaded];
}
